import { render, staticRenderFns } from "./CardObject.vue?vue&type=template&id=10d5e70e&scoped=true&"
import script from "./CardObject.vue?vue&type=script&lang=js&"
export * from "./CardObject.vue?vue&type=script&lang=js&"
import style0 from "./CardObject.vue?vue&type=style&index=0&id=10d5e70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5e70e",
  null
  
)

export default component.exports